import ButtonWithSpinner from '../../../components/buttons/ButtonWithSpinner';
import { logout } from '../../../services/LoginService';
import { filterUndefined } from '../../../utils/FilterUndefinedObject';
import './UserVerifyInvalidToken.scss';

const defaultProps = {
  errorMessage: '',
};

const UserVerifyInvalidToken = (props) => {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const { errorMessage } = mergedProps;
  return (
    <div className='user-verify-invalid-token'>
      <div className='message'>
        {errorMessage}
      </div>
      <div className='actions'>
        <ButtonWithSpinner
          className='btn-primary'
          label='Return to Login Page'
          fullWidth
          onClick={() => {
            logout(false);
          }}
        />
      </div>
    </div>
  );
};

export default UserVerifyInvalidToken;
